// ExplorePage: Explore's main column. The range's AI work read through the one
// search (FleetMap): the overview, or one kind of thing it reached, a part at
// a time. It holds no workspace. A search started from, or a session's board
// opened, goes to Workspaces (`onOpenWorkspace`), so investigating is never a
// part of this page.
import { useCallback } from "react";
import FleetMap from "../components/FleetMap.jsx";
import { newTraceCanvas } from "../lib/traceCanvasStore.js";

// The page stands on the workspace's ground inside its frame, as a blank
// pane of the workspace home did.
const GROUND = { "--bg": "var(--workspace-bg)", "--plot-bg": "var(--workspace-bg)" };

export default function ExplorePage({ range = "1M", onOpenWorkspace = null }) {
  // The search's start: a workspace holding the search (when it has clauses)
  // and the sessions picked into it, opened in Workspaces.
  const onStartSearch = useCallback((q, sessions = []) => {
    const id = newTraceCanvas({ title: q || sessions[0]?.title || "", searches: q ? [{ q, label: q }] : [], sessions });
    if (id) onOpenWorkspace?.(id);
  }, [onOpenWorkspace]);
  return (
    <div className="h-full min-h-0 min-w-0 bg-[color:var(--bg)] pb-[10px] pr-[10px] pt-[11px]" data-explore-page="">
      <section aria-label="Explore" className="h-full min-h-0 min-w-0 overflow-hidden rounded-[10px] border border-[color:var(--line)]" style={GROUND}>
        <FleetMap range={range} onStartSearch={onStartSearch} startLabel="Open this search in an investigation" startHint="open it in an investigation" />
      </section>
    </div>
  );
}
